export default "__VITE_ASSET__B$Ldd3SN__"